import { render, staticRenderFns } from "./SortSelector.vue?vue&type=template&id=0d21b4e1&scoped=true&"
import script from "./SortSelector.vue?vue&type=script&lang=js&"
export * from "./SortSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d21b4e1",
  null
  
)

export default component.exports